import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Box, Button, Divider, Grid, Link, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { Container } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Form2290DownloadTemplatePopup from '@/components/ui/Form2290DownloadTemplatePopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

declare global {
  interface Window {
    Tawk_API: {
      maximize: () => void;
      minimize: () => void;
      toggle: () => void;
      showWidget: () => void;
      hideWidget: () => void;
      popup: () => void;
      onLoad?: () => void;
    };
  }
}
const Index = () => {
  const [open, setOpen] = useState(false);
  const [buttonHover, setButtonHover] = useState(false);
  const [chatButtonHover, setChatButtonHover] = useState(false);
  const [isForm2290Template, setIsForm2290Template] = useState(false);
  const openChat = () => {
    window.Tawk_API?.maximize();
  };
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 8, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 8, 31)
      );
    }, 1000);
  }, []);
  // Random component
  const Completionist = () => <span />;

  //Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
            color: '#fff',
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            color: '#fff',
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      meta={
        <Meta
          title="E-filing IRS Excise Tax Forms using TaxZerone®"
          description="Simplify tax filing with TaxZerone's e-filing service for IRS Excise Tax Forms, ensuring efficiency and accuracy in managing tax obligations."
          keywords="IRS Excise Tax Forms, Form 2290, Form 8849, Excise Tax Forms, excise tax return, HVUT, Form 8849 Schedule-6"
          canonical="excise-tax/"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <ExciseSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Form2290DownloadTemplatePopup
        isForm2290Template={isForm2290Template}
        setIsForm2290Template={setIsForm2290Template}
      />
      <Container
        sx={{
          position: 'relative',
          mt: 3,
          mb: 0,
          // maxWidth: { xs: '100%', sm: 820, md: 820, lg: 940 },
        }}
        maxWidth="lg"
        component={'section'}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #390099, #ff0054)',
            p: 1.5,
            px: 3,
            color: '#444',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="center"
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 18, md: 18, lg: '1.14rem' },
                color: '#ccc',
              }}
            >
              <strong>📢 Only 1 Day Left!</strong> E-File{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>
                Form 2290 (2026–27) Now{' '}
              </b>
              and Get Your IRS-Stamped{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>Schedule 1 Fast.</b>
            </Typography>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                  color: '#ececec',
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Aug 31, 2026
                </span>
                ):
              </Typography>
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                size="large"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#333',
                    color: '#fff',
                    boxShadow: 'none',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>

      <Box sx={{ maxWidth: 1920, mx: 'auto' }} component={'section'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Simplify{' '}
                <span className="highlight-container">
                  <span className="highlight">Excise Tax</span>
                </span>{' '}
                Compliance: Manage{' '}
                <span className="highlight-container">
                  <span className="highlight">Heavy Highway Vehicle</span>
                </span>{' '}
                <span className="highlight-container">
                  <span className="highlight">Use Taxes</span>
                </span>{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Simplify your excise tax filing process with TaxZerone and stay
                compliant. E-file and manage excise tax forms 2290, 8849, and
                2290 Amendments on the move anytime, anywhere.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Start Filing Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            // className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/excise-tax-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/excise-tax-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/excise-tax-img.png"
                  alt="E-file Excise Tax Forms with the IRS Securely & Quickly"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/excise-tax-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/excise-tax-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/excise-tax-img-sm.png"
                  alt="E-file Excise Tax Forms with the IRS Securely & Quickly"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Box>
      <Box sx={{ backgroundColor: '#f0f2f9', py: { xs: 4, md: 4 } }} component={'section'}>
        <Container maxWidth="lg" sx={{ px: 1, py: 1 }}>
          <Box sx={{ py: { md: 2, xs: 4 } }}>
            <Paper
              elevation={0}
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 5,
                mb: 0,
                background: '#fff',
                border: '1px solid #E5E7EB',

                transition: '0.35s',
                display: 'flex',
                alignItems: 'stretch',
                minHeight: { xs: 'auto', md: 320, lg: 360, xl: 400 }, // ✅ gives image room to render
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  p: { xs: 3, md: 4 },
                  pr: { md: 26, lg: 32, xl: 40 },
                }}
              >
                <Typography
                  sx={{
                    color: '#16a34a',
                    fontWeight: 700,
                    fontSize: 14,
                    textTransform: 'uppercase',
                    letterSpacing: 2,
                    mb: 1,
                  }}
                >
                  Full-Service Filing
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: 25, sm: 30, md: 33, lg: 33 },
                    mb: 2,
                  }}
                >
                  Call to File
                </Typography>

                <Typography
                  sx={{
                    lineHeight: 1.8,
                    maxWidth: 650,
                    mb: 3,
                  }}
                >
                  Call us and provide your information over the phone. We will
                  prepare and e-file your Form 2290 return for you.
                </Typography>

                <Paper
                  elevation={0}
                  onClick={() => window.open('tel:+14084447120', '_self')}
                  sx={{
                    position: 'relative',
                    width: 280,
                    height: 88,
                    borderRadius: 100,
                    border: '2px solid #16a34a',
                    bgcolor: '#fff',
                    overflow: 'hidden',
                    cursor: 'pointer',

                    '&:hover .call-text': {
                      opacity: 0,
                      transform: 'translateX(40px)',
                    },

                    '&:hover .call-icon': {
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    },
                  }}
                >
                  {/* Icon */}
                  <Box
                    className="call-icon"
                    sx={{
                      position: 'absolute',
                      left: 16,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      bgcolor: '#16a34a',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      transition: 'all .5s cubic-bezier(.4,0,.2,1)',
                      zIndex: 2,

                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        background: '#16a34a',
                        zIndex: -1,
                        animation: 'pulse 2s infinite',
                      },

                      '@keyframes pulse': {
                        '0%': { transform: 'scale(1)', opacity: 0.5 },
                        '70%': { transform: 'scale(1.8)', opacity: 0 },
                        '100%': { transform: 'scale(1.8)', opacity: 0 },
                      },
                    }}
                  >
                    <CallRoundedIcon />
                  </Box>

                  {/* Text */}
                  <Box
                    className="call-text"
                    sx={{
                      ml: 10,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      transition: 'all .5s cubic-bezier(.4,0,.2,1)',
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                      Call Now
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: 20,
                        color: '#111827',
                      }}
                    >
                      (408) 444-7120
                    </Typography>
                  </Box>
                </Paper>
              </Box>
              {/* Floating Phone */}
              <Box
                sx={{
                  position: 'absolute',
                  right: { md: 20, lg: 35 },
                  bottom: 0,
                  display: { xs: 'none', md: 'block' },
                  width: { md: 350, lg: 450, xl: 450 },
                  height: 'auto',
                  pointerEvents: 'none',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/call-file-form-2290-img.webp"
                    type="image/webp"
                  />
                  <Box
                    component="img"
                    src="/assets/images/call-file-form-2290-img.png"
                    alt="Who Qualifies for a Suspended Vehicle Exemption?"
                    sx={{
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </picture>
              </Box>
            </Paper>
          </Box>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: '#ffffff', py: { xs: 4, md: 4 } }} component={'section'} aria-labelledby="filing-options">
        <Container maxWidth="lg" sx={{ px: 1, py: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center', // center align horizontally
              width: '100%',
            }}
          >
            <Typography
              variant="h2" id="filing-options"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Other convenient ways to file
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="body1">
              Choose the filing method that's most convenient for you
            </Typography>
          </Box>

          {/* Two secondary options */}
          <Grid container spacing={3} sx={{ mt: 2 }}>
            {/* Email */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  position: 'relative',
                  height: '100%',
                  borderRadius: '32px',

                  background: '#FFFFFF',
                  border: '1px solid',
                  borderColor: buttonHover ? '#16a34a' : '#E2E8F0',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  overflow: 'hidden',
                  boxShadow: buttonHover
                    ? '0 16px 40px rgba(22,163,74,.12)'
                    : '0 4px 30px rgba(0,0,0,.02)',
                  transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                }}
              >
                {/* Left Side: The Giant Visual Statement Block */}
                <Box
                  className="giant-icon-panel"
                  sx={{
                    width: { xs: '100%', md: '220px' },
                    minHeight: { xs: '140px', md: 'auto' },
                    background: buttonHover
                      ? 'linear-gradient(135deg,#15803d 0%,#16a34a 100%)'
                      : 'linear-gradient(135deg,#284685 0%,#1f2937 100%)',
                    position: 'relative',
                    overflow: 'hidden',
                    transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                  }}
                >
                  {/* MASSIVE ICON taking up the whole background layer */}
                  <EmailRoundedIcon
                    className="giant-icon"
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: buttonHover
                        ? 'translate(-50%, -50%) scale(1.1) rotate(-15deg)'
                        : 'translate(-50%, -50%) rotate(-4deg)',
                      fontSize: { xs: 120, md: 180 },
                      color: '#fff',
                      opacity: buttonHover ? 1 : 0.85,
                      transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                    }}
                  />

                  {/* Crisp minimalist tag placed over the dark panel */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 24,
                      left: 24,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      bgcolor: 'rgba(255,255,255,0.08)',
                      backdropFilter: 'blur(8px)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      px: 1.5,
                      py: 0.6,
                      borderRadius: '10px',
                    }}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        bgcolor: '#4ade80',
                        borderRadius: '50%',
                      }}
                    />
                    <Typography
                      sx={{
                        color: '#FFFFFF',
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                      }}
                    >
                      Email
                    </Typography>
                  </Box>
                </Box>

                {/* Right Side: Clean Typography Canvas */}
                <Box
                  sx={{
                    flex: 1,
                    p: { xs: 4, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    {/* Title */}
                    <Typography variant='h3'
                      sx={{
                        fontWeight: 900,
                        fontSize: { xs: '1.5rem', md: '1.85rem' },
                        color: '#111827',
                        letterSpacing: '-0.8px',
                        lineHeight: 1.2,
                        mb: 2.5,
                      }}
                    >
                      Email Your Information
                    </Typography>

                    {/* Description Text */}
                    <Typography
                      sx={{
                        fontSize: '1rem',
                        lineHeight: 1.7,
                        color: '#4b5563',
                        mb: 4,
                      }}
                    >
                      Download our free{' '}
                      <Link
                        onClick={() => setIsForm2290Template(true)}
                        sx={{ color: '#0202ff', cursor: 'pointer' }}
                      >
                        Form 2290 Excel template
                      </Link>{' '}
                      fill in the required details, and email it to{' '}
                      <strong>support@taxzerone.com</strong>
                    </Typography>

                    {/* High-visibility Copy-block design for the Email Address */}
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 1.5,
                        bgcolor: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        p: '8px 16px',
                        borderRadius: '12px',
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          color: '#16a34a',
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          fontFamily: 'monospace',
                        }}
                      >
                        Available 24/7
                      </Typography>
                    </Box>
                  </Box>

                  {/* Primary High-Contrast Button at the bottom right */}
                  <Box
                    sx={{ mt: 5, display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <Button
                      className="action-button"
                      variant="contained"
                      href="mailto:support@taxzerone.com"
                      endIcon={<ArrowForwardRoundedIcon />}
                      onMouseEnter={() => setButtonHover(true)}
                      onMouseLeave={() => setButtonHover(false)}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '14px',
                        px: 4,
                        py: 1.6,
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        bgcolor: buttonHover ? '#15803d' : '#16a34a',
                        color: '#fff',
                        boxShadow: buttonHover
                          ? '0 12px 28px rgba(22,163,74,.3)'
                          : '0 4px 14px rgba(22,163,74,.15)',
                        transition: 'all .35s cubic-bezier(.16,1,.3,1)',

                        '&:hover': {
                          bgcolor: '#15803d',
                        },

                        '& .MuiButton-endIcon': {
                          transition: 'all .35s ease',
                          transform: buttonHover
                            ? 'translateX(6px) rotate(-20deg)'
                            : 'translateX(0) rotate(0deg)',
                        },
                      }}
                    >
                      Email Us to File
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Live Chat */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  position: 'relative',
                  height: '100%',
                  borderRadius: '32px',
                  background: '#FFFFFF',
                  border: '1px solid',
                  borderColor: chatButtonHover ? '#16a34a' : '#E2E8F0',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  overflow: 'hidden',
                  boxShadow: chatButtonHover
                    ? '0 16px 40px rgba(22,163,74,.12)'
                    : '0 4px 30px rgba(0,0,0,.02)',
                  transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                }}
              >
                {/* Left Side */}
                <Box
                  sx={{
                    width: { xs: '100%', md: '220px' },
                    minHeight: { xs: '140px', md: 'auto' },
                    background: chatButtonHover
                      ? 'linear-gradient(135deg,#15803d 0%,#16a34a 100%)'
                      : 'linear-gradient(135deg,#284685 0%,#1f2937 100%)',
                    position: 'relative',
                    overflow: 'hidden',
                    transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                  }}
                >
                  <ChatRoundedIcon
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: chatButtonHover
                        ? 'translate(-50%, -50%) scale(1.1) rotate(-15deg)'
                        : 'translate(-50%, -50%) rotate(-4deg)',
                      fontSize: { xs: 120, md: 180 },
                      color: '#fff',
                      opacity: chatButtonHover ? 1 : 0.85,
                      transition: 'all .45s cubic-bezier(.16,1,.3,1)',
                    }}
                  />

                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 24,
                      left: 24,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      bgcolor: 'rgba(255,255,255,.08)',
                      backdropFilter: 'blur(8px)',
                      border: '1px solid rgba(255,255,255,.12)',
                      px: 1.5,
                      py: 0.6,
                      borderRadius: '10px',
                    }}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        bgcolor: '#4ade80',
                        borderRadius: '50%',
                      }}
                    />

                    <Typography
                      sx={{
                        color: '#fff',
                        fontSize: '.72rem',
                        fontWeight: 700,
                        letterSpacing: '.5px',
                      }}
                    >
                      Live Chat
                    </Typography>
                  </Box>
                </Box>

                {/* Right Side */}
                <Box
                  sx={{
                    flex: 1,
                    p: { xs: 4, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography variant='h3'
                      sx={{
                        fontWeight: 900,
                        fontSize: { xs: '1.5rem', md: '1.85rem' },
                        color: '#111827',
                        letterSpacing: '-0.8px',
                        lineHeight: 1.2,
                        mb: 2.5,
                      }}
                    >
                      Live Chat with an Expert
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '1rem',
                        lineHeight: 1.7,
                        color: '#4b5563',
                        mb: 4,
                      }}
                    >
                      Start a live chat with our{' '}
                      <strong>2290 specialists</strong>, provide your filing
                      details, and we will file your return on behalf of you.
                    </Typography>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 1.5,
                        bgcolor: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        px: 2,
                        py: 1,
                        borderRadius: '12px',
                      }}
                    >
                      <Typography
                        sx={{
                          color: '#16a34a',
                          fontWeight: 700,
                          fontSize: '.9rem',
                        }}
                      >
                        Mon – Fri • 9 AM – 5 PM CST
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      mt: 5,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={openChat}
                      onMouseEnter={() => setChatButtonHover(true)}
                      onMouseLeave={() => setChatButtonHover(false)}
                      endIcon={<ArrowForwardRoundedIcon />}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '14px',
                        px: 4,
                        py: 1.6,
                        fontWeight: 700,
                        fontSize: '.95rem',
                        bgcolor: chatButtonHover ? '#15803d' : '#16a34a',
                        boxShadow: chatButtonHover
                          ? '0 12px 28px rgba(22,163,74,.28)'
                          : '0 4px 14px rgba(22,163,74,.15)',
                        transition: 'all .35s cubic-bezier(.16,1,.3,1)',

                        '&:hover': {
                          bgcolor: '#15803d',
                        },

                        '& .MuiButton-endIcon': {
                          transition: '.35s',
                          transform: chatButtonHover
                            ? 'translateX(6px) rotate(-20deg)'
                            : 'translateX(0) rotate(0deg)',
                        },
                      }}
                    >
                      Start Live Chat
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: '#f0f2f9', py: { xs: 4, md: 4 } }} component={'section'} aria-labelledby="excise-forms">
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            m={2}
            mt={5}
            pb={5}
            mb={{ xs: 5, sm: 5 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2" id="excise-forms"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                File Excise Tax Forms with the IRS using TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for simple, quick, and secure e-file.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'article'}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{ fontSize: { xs: 24 }, fontWeight: 600, lineHeight: 1.5 }}
                >
                  Form 2290
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 96 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Heavy Highway Vehicle Use Tax Return
                  </Link>{' '}
                  File and pay the HVUT tax for your heavy vehicle and get
                  IRS-stamped Schedule 1 in minutes.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Pricing starts at&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#1da94a',
                          fontStyle: 'normal',
                        }}
                      >
                        $19.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                      >
                        E-file Form 2290
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/2290-img.webp" />
                    <source srcSet="/assets/images/2290-img.png" />
                    <img
                      src="/assets/images/2290-img.png"
                      alt="Form 2290 - Heavy Highway Vehicle Use Tax Return"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'article'}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{ fontSize: { xs: 24 }, fontWeight: 600, lineHeight: 1.5 }}
                >
                  Form 8849 - Schedule 6
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 96 }}>
                  Use{' '}
                  <Link
                    href="/excise-tax/efile-irs-form-8849-schedule-6-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule 6
                  </Link>{' '}
                  to claim a refund or credit for Federal excise taxes you paid
                  on form 2290.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#1da94a',
                          fontStyle: 'normal',
                        }}
                      >
                        $29.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                      >
                        E-file Form 8849
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedule-6-img.webp" />
                    <source srcSet="/assets/images/schedule-6-img.png" />
                    <img
                      src="/assets/images/schedule-6-img.png"
                      alt="Form 8849 - Schedule 6"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'article'}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{ fontSize: { xs: 24 }, fontWeight: 600, lineHeight: 1.5 }}
                >
                  Form 2290 VIN Correction
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 120 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    VIN correction
                  </Link>{' '}
                  File a correction with the IRS if you have mistakenly reported
                  your VIN in Form 2290 and get the updated Schedule 1 copy.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#1da94a',
                          fontStyle: 'normal',
                        }}
                      >
                        FREE
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                      >
                        E-file VIN Correction
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/vin-img.webp" />
                    <source srcSet="/assets/images/vin-img.png" />
                    <img
                      src="/assets/images/vin-img.png"
                      alt="Form 2290 VIN Correction"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'article'}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{ fontSize: { xs: 24 }, fontWeight: 600, lineHeight: 1.5 }}
                >
                  Form 2290 Amendment
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 120 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-mileage-exceeded-amendment/"
                    sx={{ color: '#0202ff' }}
                  >
                    Exceeded mileage limit
                  </Link>{' '}
                  File a Form 2290 correction with the IRS if your vehicle has
                  exceeded the mileage limit, and get the updated Schedule 1
                  copy.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Pay just&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#1da94a',
                          fontStyle: 'normal',
                        }}
                      >
                        $24.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                      >
                        E-file 2290 Amendment
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/amendment-img.webp" />
                    <source srcSet="/assets/images/amendment-img.png" />
                    <img
                      src="/assets/images/amendment-img.png"
                      alt="Form 2290 Amendment - Exceeded mileage limit"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'article'}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{ fontSize: { xs: 24 }, fontWeight: 600, lineHeight: 1.5 }}
                >
                  Form 2290 Amendment
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, minHeight: 120 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-weight-increased-amendment/"
                    sx={{ color: '#0202ff' }}
                  >
                    Taxable gross weight increased
                  </Link>{' '}
                  File a Form 2290 correction with the IRS if your
                  vehicle&apos;s taxable gross weight has increased, and get the
                  updated Schedule 1 copy.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Pay just&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 28, sm: 32, md: 32 },
                          fontWeight: 700,
                          color: '#1da94a',
                          fontStyle: 'normal',
                        }}
                      >
                        $24.99
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                      >
                        E-file 2290 Amendment
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/amendment-img.webp" />
                    <source srcSet="/assets/images/amendment-img.png" />
                    <img
                      src="/assets/images/amendment-img.png"
                      alt="Form 2290 Amendment - Taxable gross weight increased"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: '#ffffff', py: { xs: 4, md: 4 } }} component={'section'} aria-labelledby="how-to-file">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2" id="how-to-file"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Get your stamped Schedule 1 in 3 simple steps
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Whether you file Form 2290 or a VIN correction, all it takes is
                3 simple steps.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: 0, md: 5, lg: 8 },
              }}
            >
              <Box
                component="iframe"
                title="What is Form 2290: A Comprehensive Guide"
                src="https://www.youtube.com/embed/QnUmGYD2yLw?&rel=0"
                sx={{
                  width: { xs: '100%', sm: 700, md: 550, lg: 900 },
                  height: { xs: 225, sm: 393, md: 309, lg: 506 },
                  border: '10px solid #333 !important',
                  borderRadius: 5,
                }}
                allowFullScreen={true}
              />
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: { xs: 'left', sm: 'left' },
                }}
              >
                To{' '}
                <span style={{ fontWeight: 600 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    file Form 2290
                  </Link>
                </span>
                ,
              </Typography>
              <Box component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Form Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Form Information
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review and pay the tax due"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review and pay the tax due
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Transmit & get Schedule 1"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Transmit & get Schedule 1
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Divider sx={{ mb: 3, mt: -3 }} />
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: { xs: 'left', sm: 'left' },
                }}
              >
                To{' '}
                <span style={{ fontWeight: 600 }}>
                  <Link
                    href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    file a VIN correction
                  </Link>
                </span>
                ,
              </Typography>
              <Box component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter form information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter form information
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Preview the return"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Preview the return
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Transmit & get updated Schedule 1"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Transmit & get updated Schedule 1
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Ready to file form 2290?
              </Typography>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 2, sm: 4 },
                    mb: { xs: 2, sm: 2, md: 5 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
                >
                  E-file form 2290 Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Box
        sx={{ backgroundColor: '#f0f2f9', py: { xs: 4, md: 4 } }}
        className="dotted-curve"
        component={'section'} aria-labelledby="benefits"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2" id="benefits"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for Excise Form Filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Here are the best benefits truckers get by filing excise tax
                forms with TaxZerone
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }} sx={{ justifyContent: 'center', px: 0, listStyleType: 'none' }} component={'ul'}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy e-filing
                </Typography>
                <Typography variant="body1">
                  File your excise tax returns easily and hassle-free. With our
                  user-friendly interface, you can quickly enter your tax
                  details and submit your return within minutes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing
                </Typography>
                <Typography variant="body1">
                  Follow our step-by-step instructions and complete your return
                  accurately. Reduce the chances of rejection and ensure that
                  your tax return is filed the first time correctly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Smart validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart validations
                </Typography>
                <Typography variant="body1">
                  Get your returns validated for errors and discrepancies and
                  correct any errors before transmitting them. No more
                  rejections for basic items, as we&apos;ll get that sorted for
                  you.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component={'li'}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Quick and secure e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick and secure e-filing
                </Typography>
                <Typography variant="body1">
                  File excise forms online with TaxZerone in just 5 minutes and
                  transmit them to the IRS securely. It&apos;s that simple.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Schedule 1"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1
                </Typography>
                <Typography variant="body1">
                  Get Schedule 1 as soon as you complete the filing process. No
                  more waiting for the paper Schedule 1 to arrive in the mail.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component={'li'}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free retransmission of rejected returns"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free retransmission of rejected returns
                </Typography>
                <Typography variant="body1">
                  Even if the IRS rejects your return due to any reason, you can
                  correct and retransmit it to the IRS for free. No additional
                  charges.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component={'section'}
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          E-file excise forms with TaxZerone & stay tax compliant
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Make the e-filing process simple and hassle-free by clicking the
          button below.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=excise`}
          >
            Start E-filing
          </Button>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component={'section'} aria-labelledby="excise-faqs"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              my={{ xs: 2, sm: 5 }}
              mb={3}
            >
              <Typography
                variant="h2" id="excise-faqs"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                FAQs on Excise Tax Forms
              </Typography>
              <Box
                component="div"
                sx={{ mb: 5 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box component={'article'}
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"

                  >
                    1. What is IRS Form 2290?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography itemProp="text">
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 2290
                      </Link>{' '}
                      is used to report and pay the HVUT for heavy vehicles with
                      a taxable gross weight of 55,000 pounds or more. You are
                      not required to pay the HVUT for vehicles that run less
                      than 5,000 miles (7,500 miles for agricultural vehicles)
                      but are required to file Form 2290.
                    </Typography>
                  </Box>
                </Box>
                <Box component={'article'}
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"

                  >
                    2. When is the due date for Form 2290?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography itemProp="text">
                      The{' '}
                      <Link
                        href="/resources/excise-tax/form-2290-due-dates/"
                        sx={{ color: '#0202ff' }}
                      >
                        due date for filing Form 2290
                      </Link>{' '}
                      is generally August 31st of each year. However, if a
                      vehicle is first used on a public highway during the tax
                      year, the owner must file the form by the last day of the
                      month following the month in which the vehicle was first
                      used. For example, if your vehicle&apos;s first used month
                      is February, you will need to file Form 2290 by March
                      31st.
                    </Typography>
                  </Box>
                </Box>
                <Box component={'article'}
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    3. When should I file a VIN correction?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography itemProp="text">
                      You need to file a VIN correction with the IRS as soon as
                      you discover an error in the VIN after submitting your
                      Form 2290.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  sx={{
                    borderWidth: 2,
                    borderRadius: 3,
                    textTransform: 'none',
                    '&:hover, &:focus, &:active': { borderWidth: 2 },
                  }}
                  href="/faqs/form-2290/"
                >
                  More FAQs
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default Index;
